import React from "react";
import Collapse from "../../components/Collapse";
const Implementation: React.FC = () => {
  return (
    <React.Fragment>
      <div className="bg-[url('https://static.igem.wiki/teams/5058/novas-imagens/banner-novo-implamation.webp')]  bg-no-repeat bg-center w-full  h-[36em] bg-contain" />
      <img
        src="https://static.igem.wiki/teams/5058/implementation-1.svg"
        alt=""
        className="w-full h-[20%] scale-50"
      />
      <Collapse>
        <Collapse.Title>Product design and End users</Collapse.Title>
        <Collapse.Content>
          <p>
            Brazil is the largest rice producer in Latin America and one of the
            largest in the world. The production is concentrated in three
            states, but these are far from the production state: Rio de Janeiro.
            Therefore, we must facilitate product transportation. With that in
            mind, our team searched for the best way to distribute our YOB3 and
            concluded that a lyophilized powder form would be light and easy to
            pack. The packaging would already contain the space for the water
            that the consumers must add before using the product, so it would
            successfully spread through the soil. After the fermentation
            process, the rich NR flocculated yeast cells will be lyophilized and
            packaged, to ease transport. The design of the package must combine
            ideal isolation and storage, while still being market-appealing. As
            our team takes environmental matters very seriously, and as our
            project aims to impact them positively, our product design could not
            be different. Our packaging will use green plastic, derived from
            sugar cane. Since Brazil is the largest sugarcane producer in the
            world according to the Institute of Agricultural Economics (IEA),
            our team commits to using this planet-friendly source as much as
            possible: from our culture medium to our product packaging. Another
            important aspect of our product design is that it must not only be
            good for the environment but also good for the consumers. Therefore,
            we encourage our buyers to keep their YOB3 used packings, and buy
            the product refill. By doing so, we cut down on packaging demand,
            consequently cutting down on our raw material demand, and at the
            same time making the product cheaper for returning customers. This
            also facilitates transportation, since it’s easier to transport the
            smaller package only containing the powder.
          </p>
        </Collapse.Content>
      </Collapse>
      <img
        src="https://static.igem.wiki/teams/5058/implementation.svg"
        alt=""
        className="w-full h-[20%]"
      />
      <Collapse>
        <Collapse.Title>IMPLAMENTATION</Collapse.Title>
        <Collapse.Content>
          <p>
            Market research: Nowadays, NR production is mostly made by chemical
            synthesis, which is more expensive and unnatural than using
            microorganisms as biological machines; Upscaling: The choice of
            using the sugarcane medium was made since it is a rich medium for
            the yeast, an affordable medium for the industry, and its byproduct
            isn’t harmful to the planet; Production: Since NR is mostly
            concentrated inside the cell, after the yeast’s growth in the
            bioreactor, the dead cells will be collected and we’ll use an
            industrial spray dryer to turn them into a uniform and fine powder.;
            Regulatory processes: Before launching the project, we’ll make sure
            to follow all the national legislation on GMO use in agriculture. To
            do so, we interviewed experts in areas such as ethics, environmental
            engineering, and intellectual propriety.; Market launch: When all is
            set and done, we’ll launch our biostimulant in the market in both
            forms: the complete packaging and the refill. Impact assessment:
            Even though we made our product to be the safest possible it is
            important to continuously evaluate our impact on plantations and
            consumer's products. We'll also have a specific email address for
            the consumers to send us reports on the product, having a continuous
            open conversation channel in case any doubts arise.
          </p>
        </Collapse.Content>
      </Collapse>
    </React.Fragment>
  );
};

export default Implementation;
